'use strict';

import { getLoginRequiredResolveObj } from '../shared/utils/angularUtils';
import { NAVIGATION_ICON } from '../shared/constants/system/navigationIcons';

import { SOLUTION_TYPE } from '../shared/constants/user-info/solutionType';

export const reportsModule = angular
  .module('app.entityManagement', [])
  .config(reportsConfig);

reportsConfig.$inject = ['$routeProvider'];

function reportsConfig($routeProvider) {
  $routeProvider
    .when('/entities-list', {
      template: '<ngz-entity-list list-mode="NUTRITION"></ngz-entity-list>',
      resolve: getLoginRequiredResolveObj(),
      pageConfig: {
        solution: SOLUTION_TYPE.NUTRITION,
        breadcrumbs: [
          { label: 'Entities', icon: NAVIGATION_ICON.WORK }
        ]
      }
    })
    .when('/entities-list/scan-iq', {
      template: '<ngz-entity-list list-mode="SCAN_IQ"></ngz-entity-list>',
      resolve: getLoginRequiredResolveObj(),
      pageConfig: {
        solution: SOLUTION_TYPE.SCAN_IQ,
        breadcrumbs: [
          { label: 'Entities', icon: NAVIGATION_ICON.WORK }
        ]
      }
    })
    .when('/nutrition/entity-setup-flow-2024', {
      template: '<ngz-entity-flow-2024-setup></ngz-entity-flow-2024-setup>',
      resolve: getLoginRequiredResolveObj(),
      pageConfig: {
        solution: SOLUTION_TYPE.NUTRITION,
        breadcrumbs: [
          { label: 'Entity Setup', icon: NAVIGATION_ICON.WORK }
        ]
      }
    })
    .when('/scan-iq/entity-setup-flow-2024', {
      template: '<ngz-entity-flow-2024-setup></ngz-entity-flow-2024-setup>',
      resolve: getLoginRequiredResolveObj(),
      pageConfig: {
        solution: SOLUTION_TYPE.SCAN_IQ,
        breadcrumbs: [
          { label: 'Entity Setup', icon: NAVIGATION_ICON.WORK }
        ]
      }
    })
    .when('/entity-settings', {
      template: '<ngz-entity-settings-page></ngz-entity-settings-page>',
      resolve: getLoginRequiredResolveObj(),
      pageConfig: {
        solution: null,
        breadcrumbs: [
          { label: 'Settings', icon: NAVIGATION_ICON.SETTINGS }
        ]
      }
    })
    .when('/teams', {
      template: '<ngz-teams-page></ngz-teams-page>',
      resolve: getLoginRequiredResolveObj(),
      pageConfig: {
        solution: SOLUTION_TYPE.NUTRITION,
        breadcrumbs: [
          { label: 'Teams', icon: NAVIGATION_ICON.PEOPLE_OUTLINE }
        ]
      }
    })
    .when('/entity-dashboard', {
      template: '<ngz-entity-dashboard></ngz-entity-dashboard>',
      resolve: getLoginRequiredResolveObj(),
      pageConfig: {
        solution: null,
        breadcrumbs: [
          { label: 'Dashboard', icon: NAVIGATION_ICON.DASHBOARD }
        ]
      }
    });
}
